import {memo} from "react";
// local
import {CustomTooltip} from "components/CustomTooltip";

export const SignContractAuthenticatedVerificationIcon = memo(
  ({onOpen, tooltipKey, Icon}) => (
    <span className="df-row-center fs0 mr-2">
      <CustomTooltip text={tooltipKey}>
        <span
          className="df-row-center fs0 cpointer"
          role="button"
          tabIndex={0}
          onClick={onOpen}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onOpen();
            }
          }}
        >
          <Icon />
        </span>
      </CustomTooltip>
    </span>
  )
);
